import { canvasImgAnimatedTpl } from './canvas';
export { canvasImgAnimatedTpl }